// extracted by mini-css-extract-plugin
export default {"container":"TnqEc3Kp","icon":"UNtYrmUD","iconContainer":"CywNsfWH","label":"MPmNfSUo","item":"IR8q0XAZ"};